export default __webpack_public_path__ + "static/media/tyler.47617664.png";